import {  TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";

const Header = ({ adStatus }: { adStatus: string }) => {
    return (
        <TableHead>
            {adStatus === "active" || adStatus === "past" ? (
                <TableRow>
                    <TableCell>
                        <Typography variant="body2">Campaign</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Tooltip title={"Number of times users viewed the ad"}>
                            <Typography variant="body2">Impressions</Typography>
                        </Tooltip>
                    </TableCell>
                    <TableCell align="right">
                        <Tooltip title={"Number of times users looked at the ad for an extended period of time"}>
                            <Typography variant="body2">Quality</Typography>
                        </Tooltip>
                    </TableCell>
                    <TableCell align="right">
                        <Tooltip title={"Number of times users clicked the ad"}>
                            <Typography variant="body2">Clicks</Typography>
                        </Tooltip>
                    </TableCell>
                    <TableCell align="right">
                        <Tooltip title={"Number of conversions"}>
                            <Typography variant="body2">Conversions</Typography>
                        </Tooltip>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="body2">Spend</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="body2">Start Time</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="body2">End Time</Typography>
                    </TableCell>
                    {adStatus === "active" &&
                        <TableCell align="right" width={140}>
                            <Typography variant="body2">Actions</Typography>
                        </TableCell>
                    }
                </TableRow>
            ) : adStatus === "draft" ? (
                <TableRow>
                    <TableCell>
                        <Typography variant="body2">Campaign</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="body2">Actions</Typography>
                    </TableCell>
                </TableRow>
            ) : (
                <TableRow>
                    <TableCell>
                        <Typography variant="body2">Campaign</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="body2">Status</Typography>
                    </TableCell>
                    <TableCell align="right">
                        <Typography variant="body2">Actions</Typography>
                    </TableCell>
                </TableRow>
            )}
        </TableHead>
    )
}

export default Header;
